import classNames from 'classnames';
import React from 'react';
import Spacing from './consts/spacing';
import styles from './divider.module.scss';

export type DividerProps = {
	borderWidth?: number;
	spacing?: Spacing;
	className?: string;
};

const Divider: React.FC<DividerProps> = ({ borderWidth = 1, spacing = Spacing.NONE, className = '' }) => {
	const borderStyles = {
		borderWidth: `${borderWidth ?? 1}px`
	};

	const borderWrapperStyles = {
		margin: `${spacing ?? Spacing.NONE}px 0`
	};

	const combinedClassName = classNames(className, styles.bringgDivider);

	return (
		<div className="divider-wrapper" style={borderWrapperStyles}>
			<div className={combinedClassName} style={borderStyles} />
		</div>
	);
};

export default Divider;
